module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tutorials-examples-stopwatch.json
// module id = 822
// module chunks = 38723441077014